import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { Button } from '@/shared/ui/button'

interface ConfirmButtonProps {
  onConfirm: () => void
  confirmLabel?: string
  pending?: boolean
  size?: 'md' | 'sm'
  className?: string
  children: ReactNode
}

// Двухшаговое опасное действие: первый клик «взводит», второй выполняет.
// Браузерные confirm-диалоги не используются намеренно.
export function ConfirmButton({
  onConfirm,
  confirmLabel = 'Точно?',
  pending = false,
  size = 'md',
  className,
  children,
}: ConfirmButtonProps) {
  const [armed, setArmed] = useState(false)

  useEffect(() => {
    if (!armed) return
    const t = setTimeout(() => setArmed(false), 3000)
    return () => clearTimeout(t)
  }, [armed])

  return (
    <Button
      variant="danger"
      size={size}
      pending={pending}
      className={className}
      onClick={() => {
        if (armed) {
          setArmed(false)
          onConfirm()
        } else {
          setArmed(true)
        }
      }}
    >
      {armed ? confirmLabel : children}
    </Button>
  )
}
